<template>
    <div class="product-card">
        <div class="content">
            <div v-if="data.image" class="img" :style="styles"></div>
            <div v-else class="blank-img"></div>

            <basic-button :reverse="true" label="Contratar" :width="280" @click="openModal = true" />
        </div>

        <ProductModal v-if="openModal" :data="data" @close-modal="openModal = false" />
    </div>
</template>

<script setup>
import { ref, computed } from 'vue'

import BasicButton from '../buttons/BasicButton.vue'
import ProductModal from '../modals/ProductModal.vue'

import fgts from '../../assets/img/products/fgts.png'
import consorcio from '../../assets/img/products/consorcio.png'
import consultoria from '../../assets/img/products/consultoria.png'
import curso from '../../assets/img/products/curso.png'
import emprestimo from '../../assets/img/products/emprestimo.png'
import investimento from '../../assets/img/products/investimento.png'

const imgs = {
    fgts,
    consorcio,
    consultoria,
    curso,
    emprestimo,
    investimento,
}

const props = defineProps({
    data: {
        type: Object,
        required: true,
    },
})

function resolveImg() {
    if (props.data.image.includes('http')) return props.data.image
    return imgs[props.data.image]
}

const styles = computed(() => ({
    '--background': `url(${resolveImg()})`,
}))

const openModal = ref(false)
</script>

<style lang="scss">
.product-card {
    width: 330px;
    height: 280px;
    margin: 0 24px 50px 0;
    border-radius: 4px;
    position: relative;
    box-shadow: 0px 0px 10px #0000002b;
    padding: 0 0 24px 0;

    .img {
        height: 70%;
        width: 100%;
        background: white var(--background) no-repeat;
        background-position-x: center;
        background-position-y: center;
        background-size: cover;
    }

    .blank-img {
        width: 100%;
        height: 75%;
        background: gray;
        opacity: 0.5;
    }

    .content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        height: 100%;
    }
}
</style>
